import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const RdbmsInternalError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsInternalError'),
  errorReason: z.string(),
  errorCode: z.string().optional(),
});

export type RdbmsInternalError = z.infer<typeof RdbmsInternalError>;

export const RdbmsConfigError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsConfigError'),
  errorReason: z.string(),
});

export type RdbmsConfigError = z.infer<typeof RdbmsConfigError>;

export const RdbmsValidationError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsValidationError'),
  errorReason: z.string(),
});

export type RdbmsValidationError = z.infer<typeof RdbmsValidationError>;

export const RdbmsEntityNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsEntityNotFoundError'),
  errorReason: z.string(),
});

export type RdbmsEntityNotFoundError = z.infer<typeof RdbmsEntityNotFoundError>;

export const RdbmsRlsError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsRlsError'),
  errorReason: z.string(),
});

export type RdbmsRlsError = z.infer<typeof RdbmsRlsError>;

export const RdbmsForeignKeyViolationError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsForeignKeyViolationError'),
  errorReason: z.string(),
});

export type RdbmsForeignKeyViolationError = z.infer<
  typeof RdbmsForeignKeyViolationError
>;

export const RdbmsUniqueViolationError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsUniqueViolationError'),
  errorReason: z.string(),
});

export type RdbmsUniqueViolationError = z.infer<
  typeof RdbmsUniqueViolationError
>;

export const RdbmsNotNullViolationError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsNotNullViolationError'),
  errorReason: z.string(),
});

export type RdbmsNotNullViolationError = z.infer<
  typeof RdbmsNotNullViolationError
>;

export const RdbmsCheckViolationError = BaseErrorSchema.extend({
  errorType: z.literal('RdbmsCheckViolationError'),
  errorReason: z.string(),
});

export type RdbmsCheckViolationError = z.infer<typeof RdbmsCheckViolationError>;

export const RdbmsError = z.union([
  RdbmsInternalError,
  RdbmsConfigError,
  RdbmsValidationError,
  RdbmsEntityNotFoundError,
  RdbmsRlsError,
  RdbmsForeignKeyViolationError,
  RdbmsUniqueViolationError,
  RdbmsNotNullViolationError,
  RdbmsCheckViolationError,
]);
export type RdbmsError = z.infer<typeof RdbmsError>;
